<terra-button
    [inputTooltipText]="inputTooltipText"
    [inputTooltipPlacement]="inputTooltipPlacement"
    [hidden]="inputIsHidden"
    [inputIsDisabled]="inputIsDisabled"
    [inputIcon]="inputIcon"
    [inputIsSmall]="inputIsSmall"
    [inputIsLarge]="inputIsLarge"
    (click)="_toggle()"
>
    <div
        btn-inner
        class="toggle-wrapper"
        [ngClass]="{
            active: _isActive,
            sm: inputIsSmall,
            lg: inputIsLarge,
            'float-right': inputIsAlignRight,
            disabled: inputIsDisabled
        }"
    >
        <div class="slider"></div>
    </div>
</terra-button>
